export const initialState = {
  values: [],
  changed: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnDocumentTypeXPropertyXStateChanged':
      return onDocumentTypeXPropertyXStateChanged(state, action);
    case 'OnDocumentTypeXPropertyXStateAdded':
      return onDocumentTypeXPropertyXStateAdded(state, action);
    case 'OnDocumentTypeXPropertyXStateUpdated':
      return onDocumentTypeXPropertyXStateUpdated(state, action);
    case 'OnDocumentTypeXPropertyXStateDelete':
      return onDocumentTypeXPropertyXStateDelete(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    values: data,
    changed: false
  };
}

function onDocumentTypeXPropertyXStateChanged(state, action) {
  const { propName, propValue, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        [propName]: propValue
      }
    }),
    changed: true
  };
}

function onDocumentTypeXPropertyXStateAdded(state, action) {
  const newState = {
    documentTypeId: action.documentTypeId,
    propertyId: action.propertyId,
    documentStateId: null,
    allowEdit: false
  };
  const values = state.values ? Object.assign([...state.values]) : [];
  values.push({ ...newState });
  return {
    ...state,
    values: values,
    changed: true
  };
}

function onDocumentTypeXPropertyXStateUpdated(state, _action) {
  return {
    ...state,
    changed: false
  };
}

function onDocumentTypeXPropertyXStateDelete(state, action) {
  const { index } = action;
  const newStates = Object.assign([...state.values]);
  newStates.splice(index, 1);
  return {
    ...state,
    values: newStates,
    changed: true
  };
}
